import { render, staticRenderFns } from "./EventTicket.vue?vue&type=template&id=2c1384bd"
import script from "./EventTicket.vue?vue&type=script&lang=js"
export * from "./EventTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports